import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import StyledCheckbox from '../StyledCheckbox';

const CheckBoxItem = (props) => {
  const { value, label, checked, indeterminate } = props;

  const handleCheckboxChange = (event) => {
    const { checkboxChangeCallback } = props;
    checkboxChangeCallback(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <StyledCheckbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={handleCheckboxChange}
          value={value}
        />
      }
      label={label}
    />
  );
};

export default CheckBoxItem;

CheckBoxItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool,
  checkboxChangeCallback: PropTypes.func,
};

CheckBoxItem.defaultProps = {
  checkboxChangeCallback: null,
  indeterminate: false,
};
